import request from "@/requests/request";

export const getMatIntegrations = ({
  signal,
}: IGenericHookOptions): Promise<IGetIntegrationsRS> =>
  request({
    url: "/v1/mat/integrations",
    signal,
  }).then(res => res.data);

export const postOnboardingProgression = async (
  step: IMatOnboardingStep,
): Promise<IGetCustomerSetupChecklistRS> =>
  await request({
    url: "/v1/customer-setup-checklist/complete",
    method: "POST",
    body: {
      step,
    },
  }).then(res => res.data);

export const getMatIntegrationConfiguration = ({
  integration,
  isOnboarding,
  signal,
}: IGetMatIntegrationConfigurationRQ): Promise<IGetMatIntegrationConfigurationRS> =>
  request({
    method: "GET",
    url: `/v1/mat/integrations/${integration?.toUpperCase()}/configuration${!!isOnboarding ? `?isOnboarding=${isOnboarding}` : ``}`,
    signal,
  }).then(res => res.data);

export const postMatIntegrationConfiguration = async ({
  integration,
  body,
}: IPostMatIntegrationConfigurationRQ): Promise<any> =>
  await request({
    url: `/v1/mat/integrations/${integration?.toUpperCase()}/configuration`,
    method: "POST",
    body,
  }).then(res => res.data);

export const postUninstallMatIntegration = async ({
  integration,
}: IPostUninstallMatIntegrationRQ): Promise<IGetMatIntegrationConfigurationRS> =>
  await request({
    url: `/v1/mat/integrations/${integration?.toUpperCase()}/uninstall`,
    method: "POST",
  }).then(res => res.data);

export const postMatConfirmation = async ({
  confirmationUrl,
  method,
}: {
  confirmationUrl: string;
  method: "PUT" | "POST" | "GET";
}): Promise<void> =>
  await request({
    url: confirmationUrl,
    method: method,
  }).then(res => res.data);
